<template>
  <panel no-button="true" title="List of Companies">
    <router-link class="btn outline-primary" to="/company/create">
      Add Company
    </router-link>

    <table class="table">
      <thead>
        <th>Name</th>
        <th colspan="2">Created</th>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>
            {{ item.name }}
          </td>
          <td>
            {{ item.createdAt | date }}
          </td>

          <td class="with-btn-group">
            <router-link
              class="btn outline-primary"
              :to="{ name: 'company', params: { id: item.id } }"
            >
              Edit
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </panel>
</template>

<script>
import UserMixin from '../../mixins/UserMixin'
export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  mixins: [UserMixin],
  filters: {
    date: function (value) {
      if (!value) return ''
      return new Date(value).toLocaleDateString()
    }
  }
}
</script>
